import { atom, selector } from 'recoil'
import getIntl from 'Helpers/intl'
import { PARAM_ORDER_ASC } from 'mailup-web-components'

export const searchCriteriaOptionsState = atom({
  key: 'searchCriteriaOptionsState',
  default: {
    groups: [],
    filters: []
  }
})

export const searchCriteriaState = atom({
  key: 'searchCriteriaState',
  default: {
    loading: false,
    loaded: false,
    error: false,
    severity: 'danger',
    includeGroups: [],
    excludeGroups: [],
    selectedFilters: [],
    typeAppliedFilters: 'All'
  }
})

export const dynamicFieldsState = atom({
  key: 'searchEmailWizardDynamicFieldsState',
  default: []
})

export const manageableFieldsState = selector({
  key: 'searchEmailWizardManageableFieldsState',
  get: ({ get }) => {
    const staticFields = [
      {
        id: 'Email',
        description: getIntl().formatMessage({
          id: 'Load.SearchRecipients.emailHeading'
        })
      },
      {
        id: 'MobilePrefixAndNumber',
        description: getIntl().formatMessage({
          id: 'Load.SearchRecipients.smsHeading'
        })
      }
    ]
    const dynamicFields = get(dynamicFieldsState).map(
      ({ Id, Description }) => ({
        id: typeof Id === 'number' ? `Field${Id}` : Id,
        description: `${Id} - ${Description}`
      })
    )

    return [...staticFields, ...dynamicFields]
  }
})

export const visibleColumnsState = atom({
  key: 'searchRecipientsVisibleColumnsState',
  default: []
})

export const fixedFieldsState = selector({
  key: 'searchRecipientsFixedFieldsState',
  get: ({ get }) => {
    return [
      {
        id: 'Email',
        description: getIntl().formatMessage({
          id: 'Load.SearchRecipients.emailHeading'
        })
      },
      {
        id: 'MobilePrefixAndNumber',
        description: getIntl().formatMessage({
          id: 'Load.SearchRecipients.smsHeading'
        })
      }
    ]
  }
})

export const recipientsDataTablePreviewState = atom({
  key: 'recipientsDataTablePreviewState',
  default: {
    loading: false,
    loaded: false,
    firstChange: true,
    items: undefined,
    sortBy: 'Email',
    sortOrder: PARAM_ORDER_ASC,
    sortChanged: false
  }
})

export const sendingPreviewState = atom({
  key: 'sendingPreviewState',
  default: {
    loading: false,
    loaded: false,
    showLoading: false,
    error: undefined,
    severity: undefined,
    queued: undefined,
    excludedGroups: [],
    toBeQueued: undefined,
    totalRecipients: undefined,
    diff: undefined,
    oldIncludeGroups: undefined,
    oldExcludeGroups: undefined,
    oldSelectedFilters: undefined,
    previewLoading: false
  }
})
